import { mutations } from "./const";
import { RecursiveInterval } from "@/helpers/RecursiveInterval";

let counter = null;
const dateDiff = (date1, date2) => +date1 - +date2;
export default {
  startTimer({ commit, dispatch }, expires) {
    const _expires = expires || 0;

    const callback = () => {
      const value = dateDiff(new Date(_expires * 1000), new Date());

      if (value <= 0) {
        dispatch("stopTimer");
        commit(mutations.SET_IS_EXPIRED, true);
      } else {
        commit(mutations.SET_TIME_TO_EXPIRED, value);
      }
    };

    callback();
    counter = new RecursiveInterval({
      callback,
      intervalRegulator: () => 1000,
    });

    counter.run();
  },

  stopTimer() {
    if (counter) counter.stop();
  },
};
